import script from "./BookingDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingDetail.vue?vue&type=script&setup=true&lang=ts"

import "./BookingDetail.vue?vue&type=style&index=0&id=f0fbfc7c&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0fbfc7c"]])

export default __exports__